<app-main-layout>
  <div class="bg-gray-50 min-h-screen">
  <div class="py-6 px-4 sm:px-6 max-w-[1400px] mx-auto">

    <!-- ============ HERO ============ -->
    <div class="relative overflow-hidden rounded-3xl bg-neutral-900 text-white px-6 sm:px-8 py-7 mb-6 shadow-lg">
      <div class="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-amber-400/20 blur-3xl"></div>
      <div class="pointer-events-none absolute right-10 bottom-0 opacity-[0.07]"><mat-icon class="!text-[160px] !h-[160px] !w-[160px]">tune</mat-icon></div>

      <div class="relative flex flex-col lg:flex-row lg:items-end justify-between gap-6">
        <div class="max-w-xl">
          <div class="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.15em] text-amber-400">
            <mat-icon class="!text-[14px] !h-3.5 !w-3.5">inventory_2</mat-icon> Products
          </div>
          <h1 class="mt-2 text-3xl font-bold tracking-tight">Attributes</h1>
          <p class="mt-2 text-sm text-white/60 leading-relaxed">The properties products are described by - Colour, Finish, Size - and the values each one can take.</p>
        </div>
        <button type="button"
          class="group self-start lg:self-auto flex items-center gap-2.5 pl-2.5 pr-5 py-2.5 rounded-2xl bg-amber-400 text-neutral-900 font-bold text-sm shadow-lg shadow-amber-500/20 hover:bg-amber-300 hover:-translate-y-0.5 active:translate-y-0 transition-all focus:outline-none focus:ring-4 focus:ring-amber-400/40"
          (click)="onCreate()">
          <span class="h-8 w-8 rounded-xl bg-neutral-900 text-amber-400 flex items-center justify-center transition-transform duration-200 group-hover:rotate-90">
            <mat-icon class="!text-[20px] !h-5 !w-5">add</mat-icon>
          </span>
          New attribute
        </button>
      </div>

      <div class="relative mt-7 grid grid-cols-2 sm:grid-cols-4 gap-3">
        @for (s of [
          { label: 'Attributes', value: counts.total, icon: 'tune', filter: 'ALL' },
          { label: 'Values', value: counts.values, icon: 'sell', filter: '' },
          { label: 'In use', value: counts.used, icon: 'check_circle', filter: 'USED' },
          { label: 'Not used', value: counts.unused, icon: 'radio_button_unchecked', filter: 'UNUSED' }
        ]; track s.label) {
        <button type="button" class="text-left rounded-2xl bg-white/[0.06] border border-white/10 px-4 py-3 transition-colors"
          [ngClass]="s.filter ? 'hover:bg-white/[0.1] cursor-pointer' : 'cursor-default'" (click)="s.filter && setFilter($any(s.filter))">
          <div class="flex items-center gap-1.5 text-[11px] font-semibold text-white/50 uppercase tracking-wide"><mat-icon class="!text-[14px] !h-3.5 !w-3.5">{{ s.icon }}</mat-icon>{{ s.label }}</div>
          <div class="mt-1 text-2xl font-bold tabular-nums">{{ loading ? '–' : (s.value | number) }}</div>
        </button>
        }
      </div>
    </div>

    <!-- ============ TOOLBAR ============ -->
    <div class="sticky top-0 z-20 -mx-4 sm:mx-0 px-4 sm:px-0 py-3 mb-4 bg-gray-50/90 backdrop-blur">
      <div class="flex flex-col sm:flex-row sm:items-center gap-3">
        <div class="relative flex-1">
          <mat-icon class="absolute left-3.5 top-1/2 -translate-y-1/2 !text-gray-400 !text-[20px] !h-5 !w-5 pointer-events-none">search</mat-icon>
          <input type="text" placeholder="Search by attribute name, slug or value…"
            class="w-full pl-11 pr-10 py-2.5 rounded-xl border border-gray-200 bg-white shadow-sm focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm"
            [ngModel]="search" (ngModelChange)="onSearch($event)" />
          @if (search) {
          <button class="absolute right-2.5 top-1/2 -translate-y-1/2 h-7 w-7 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700 flex items-center justify-center" (click)="onSearch('')" aria-label="Clear search">
            <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">close</mat-icon>
          </button>
          }
        </div>
        <div class="flex bg-white border border-gray-200 rounded-xl p-1 gap-1 shadow-sm self-start">
          @for (f of [{ key: 'ALL', label: 'All', n: counts.total, tip: '' }, { key: 'USED', label: 'In use', n: counts.used, tip: 'Products use these' }, { key: 'UNUSED', label: 'Not used', n: counts.unused, tip: 'No product uses these yet' }]; track f.key) {
          <button class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all" [matTooltip]="f.tip"
            [ngClass]="filter === f.key ? 'bg-neutral-900 text-white shadow-sm' : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'" (click)="setFilter($any(f.key))">
            {{ f.label }} <span class="tabular-nums" [ngClass]="filter === f.key ? 'text-amber-400' : 'text-gray-400'">{{ f.n }}</span>
          </button>
          }
        </div>
      </div>
    </div>

    @if (loadError) {
      <div class="mb-4 bg-red-50 border border-red-200 text-red-700 rounded-2xl p-4 text-sm flex items-center justify-between">
        <span class="flex items-center gap-2"><mat-icon class="!text-[18px] !h-[18px] !w-[18px]">cloud_off</mat-icon>Could not load attributes from the server.</span>
        <button class="text-xs uppercase font-semibold underline" (click)="load()">Try again</button>
      </div>
    }

    <!-- ============ LIST ============ -->
    @if (loading) {
      <div class="flex flex-col gap-2.5">
        @for (i of [1, 2, 3, 4, 5]; track i) {
        <div class="flex items-center gap-4 rounded-2xl bg-white border border-gray-100 px-5 py-4 animate-pulse">
          <div class="h-12 w-12 rounded-2xl bg-gray-100"></div>
          <div class="flex-1"><div class="h-4 w-1/4 rounded bg-gray-100"></div><div class="mt-2 flex gap-1.5"><div class="h-5 w-14 rounded-md bg-gray-100"></div><div class="h-5 w-16 rounded-md bg-gray-100"></div><div class="h-5 w-12 rounded-md bg-gray-100"></div></div></div>
          <div class="hidden md:block h-2 w-32 rounded-full bg-gray-100"></div>
        </div>
        }
      </div>
    } @else if (visible.length === 0) {
      <div class="rounded-3xl border-2 border-dashed border-gray-200 bg-white py-16 text-center">
        <span class="mx-auto h-14 w-14 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center"><mat-icon class="!text-[28px] !h-7 !w-7">{{ search || filter !== 'ALL' ? 'search_off' : 'tune' }}</mat-icon></span>
        <p class="mt-3 text-sm font-semibold text-gray-700">{{ search || filter !== 'ALL' ? 'No attributes match' : 'No attributes yet' }}</p>
        <p class="text-xs text-gray-400">{{ search || filter !== 'ALL' ? 'Try a different search or filter' : 'Create the first attribute' }}</p>
        @if (search || filter !== 'ALL') {
          <button type="button" class="mt-4 text-xs font-semibold text-amber-700 hover:underline" (click)="search = ''; setFilter('ALL')">Clear search and filter</button>
        }
      </div>
    } @else {
      <div class="flex flex-col gap-2.5">
        @for (row of pageRows; track row.attributeId) {
        <div role="button" tabindex="0" (click)="select(row)" (keydown.enter)="select(row)"
          class="group grid grid-cols-[auto_minmax(0,1fr)_auto] md:grid-cols-[auto_minmax(0,1fr)_200px_auto] gap-x-4 gap-y-3 items-center rounded-2xl bg-white border px-4 sm:px-5 py-4 cursor-pointer transition-all duration-200 hover:-translate-y-px hover:shadow-[0_8px_24px_-12px_rgba(0,0,0,0.18)] focus:outline-none focus-visible:ring-4 focus-visible:ring-amber-100"
          [ngClass]="selectedId === row.attributeId ? 'border-amber-300 ring-4 ring-amber-100/80' : 'border-gray-100 hover:border-gray-200'">

          <!-- Badge: initial + value count -->
          <span class="h-12 w-12 rounded-2xl flex flex-col items-center justify-center flex-shrink-0 shadow-sm"
            [ngClass]="row.core ? 'bg-gradient-to-br from-neutral-700 to-neutral-900 text-amber-400 shadow-gray-300' : 'bg-gradient-to-br from-amber-300 to-amber-500 text-neutral-900 shadow-amber-200'">
            <span class="text-lg font-extrabold leading-none uppercase">{{ row.attributeName.charAt(0) }}</span>
            <span class="text-[9px] font-bold mt-0.5 opacity-70 tabular-nums">{{ row.valueCount }}</span>
          </span>

          <!-- Name + values -->
          <div class="min-w-0">
            <div class="flex items-center gap-2 min-w-0">
              <span class="text-[15px] font-semibold text-gray-900 truncate">{{ row.attributeName }}</span>
              @if (row.core) {
                <span class="flex items-center gap-0.5 text-[10px] font-semibold px-1.5 py-0.5 rounded-md bg-neutral-900 text-amber-400" matTooltip="Used by the product forms - slug is fixed, can't be deleted"><mat-icon class="!text-[11px] !h-[11px] !w-[11px]">lock</mat-icon>Core</span>
              }
              <span class="hidden sm:inline font-mono text-[11px] px-1.5 py-px rounded-md bg-gray-100 text-gray-500 truncate">{{ row.attributeSlug }}</span>
            </div>
            @if (row.previewValues.length) {
              <div class="mt-2 flex flex-wrap gap-1">
                @for (v of row.previewValues.slice(0, 6); track $index) {
                  <span class="text-[11px] font-medium px-2 py-0.5 rounded-md bg-gray-50 border border-gray-100 text-gray-600 max-w-[150px] truncate">{{ v }}</span>
                }
                @if (row.valueCount > 6) {
                  <span class="text-[11px] font-semibold px-2 py-0.5 rounded-md text-amber-700 bg-amber-50">+{{ row.valueCount - 6 }} more</span>
                }
              </div>
            } @else {
              <div class="mt-1.5 text-xs text-gray-400 italic">No values yet</div>
            }
          </div>

          <!-- Actions (top right on phones, last on desktop) -->
          <div class="md:order-last flex items-center gap-0.5 rounded-xl bg-gray-50 border border-gray-100 p-0.5 md:opacity-0 md:group-hover:opacity-100 md:group-focus-within:opacity-100 transition-opacity"
            [class.md:opacity-100]="selectedId === row.attributeId">
            <button class="h-8 w-8 rounded-lg text-gray-500 hover:bg-white hover:text-gray-900 hover:shadow-sm flex items-center justify-center" (click)="$event.stopPropagation(); select(row)" matTooltip="View" aria-label="View"><mat-icon class="!text-[17px] !h-[17px] !w-[17px]">visibility</mat-icon></button>
            <button class="h-8 w-8 rounded-lg text-gray-500 hover:bg-white hover:text-gray-900 hover:shadow-sm flex items-center justify-center" (click)="$event.stopPropagation(); onEdit(row.attributeId)" matTooltip="Edit" aria-label="Edit"><mat-icon class="!text-[17px] !h-[17px] !w-[17px]">edit</mat-icon></button>
            @if (canDelete) {
              <span [matTooltip]="deleteBlockedReason(row) || 'Delete'">
                <button class="h-8 w-8 rounded-lg text-gray-500 hover:bg-red-50 hover:text-red-600 flex items-center justify-center disabled:opacity-30 disabled:pointer-events-none" [disabled]="!!deleteBlockedReason(row)" (click)="$event.stopPropagation(); onDelete(row.attributeId)" aria-label="Delete"><mat-icon class="!text-[17px] !h-[17px] !w-[17px]">delete</mat-icon></button>
              </span>
            }
          </div>

          <!-- Usage -->
          <div class="col-span-3 md:col-span-1">
            <div class="flex items-baseline justify-between text-sm">
              @if (row.productCount) {
                <span><span class="font-bold text-gray-900 tabular-nums">{{ row.productCount | number }}</span> <span class="text-gray-500">product{{ row.productCount === 1 ? '' : 's' }}</span></span>
              } @else {
                <span class="text-xs font-semibold text-gray-400">Not used</span>
              }
              <span class="text-[11px] text-gray-400 tabular-nums">{{ row.valueCount }} value{{ row.valueCount === 1 ? '' : 's' }}</span>
            </div>
            <div class="mt-1.5 h-1.5 rounded-full bg-gray-100 overflow-hidden" [matTooltip]="row.productCount ? row.productCount + ' products - ' + usagePct(row) + '% of the most-used attribute' : ''">
              <div class="h-full rounded-full bg-gradient-to-r from-amber-300 to-amber-500 transition-all" [style.width.%]="row.productCount ? Math.max(usagePct(row), 3) : 0"></div>
            </div>
          </div>
        </div>
        }
      </div>

      <div class="mt-4 rounded-2xl bg-white border border-gray-100 shadow-sm overflow-hidden">
        <mat-paginator
          [length]="visible.length" [pageSize]="pageSize" [pageIndex]="pageIndex"
          [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons (page)="onPage($event)">
        </mat-paginator>
      </div>
    }
  </div>
  </div>

  <!-- ============ VIEW (slide-over) ============ -->
  @if (selectedId) {
  <div class="fixed inset-0 z-40 bg-black/30 backdrop-blur-[1px] at-fade" (click)="closeDetail()"></div>
  <aside class="fixed inset-y-0 right-0 z-50 w-full max-w-lg bg-white shadow-2xl flex flex-col at-slide" role="dialog" aria-modal="true" aria-label="Attribute">
    @if (detailLoading && !detail) {
      <div class="flex-1 flex items-center justify-center"><mat-spinner diameter="28"></mat-spinner></div>
    } @else if (detail) {
    <div class="relative overflow-hidden bg-neutral-900 text-white px-6 pt-6 pb-5" [class.opacity-60]="detailLoading">
      <div class="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-amber-400/20 blur-2xl"></div>
      <div class="relative flex items-start justify-between gap-3">
        <div class="min-w-0">
          <div class="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.15em] text-amber-400">
            Attribute
            @if (detail.core) { <span class="flex items-center gap-0.5 normal-case tracking-normal px-1.5 py-px rounded-md bg-amber-400 text-neutral-900"><mat-icon class="!text-[11px] !h-[11px] !w-[11px]">lock</mat-icon>Core</span> }
          </div>
          <div class="mt-1.5 text-2xl font-bold leading-tight">{{ detail.attributeName }}</div>
          <div class="text-xs text-white/50 font-mono">{{ detail.attributeSlug }}</div>
        </div>
        <button type="button" class="h-9 w-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center flex-shrink-0" (click)="closeDetail()" aria-label="Close"><mat-icon class="!text-[18px] !h-[18px] !w-[18px]">close</mat-icon></button>
      </div>
      <div class="relative mt-5 grid grid-cols-2 gap-2">
        <div class="rounded-xl bg-white/[0.07] px-3 py-2"><div class="text-[10px] uppercase tracking-wide text-white/50">Values</div><div class="text-lg font-bold tabular-nums">{{ detail.values.length | number }}</div></div>
        <div class="rounded-xl bg-white/[0.07] px-3 py-2"><div class="text-[10px] uppercase tracking-wide text-white/50">Products using it</div><div class="text-lg font-bold tabular-nums">{{ detail.productCount | number }}</div></div>
      </div>
      <div class="relative mt-4 flex gap-2">
        <button type="button" class="flex items-center gap-1.5 px-3.5 py-2 rounded-xl bg-amber-400 text-neutral-900 text-xs font-bold hover:bg-amber-300" (click)="onEdit(detail.attributeId)"><mat-icon class="!text-[16px] !h-4 !w-4">edit</mat-icon>Edit</button>
        @if (canDelete) {
          <span [matTooltip]="deleteBlockedReason(detail)">
            <button type="button" class="flex items-center gap-1.5 px-3.5 py-2 rounded-xl bg-white/10 text-white text-xs font-semibold hover:bg-red-600 disabled:opacity-40 disabled:pointer-events-none" [disabled]="!!deleteBlockedReason(detail)" (click)="onDelete(detail.attributeId)"><mat-icon class="!text-[16px] !h-4 !w-4">delete</mat-icon>Delete</button>
          </span>
        }
      </div>
    </div>

    <div class="flex-1 min-h-0 flex flex-col px-6 py-5" [class.opacity-60]="detailLoading">
      @if (detail.core) {
        <div class="mb-4 flex items-start gap-2 text-xs text-sky-800 bg-sky-50 border border-sky-100 rounded-xl px-3 py-2.5">
          <mat-icon class="!text-[16px] !h-4 !w-4 flex-shrink-0">info</mat-icon>
          <span>Used by the product forms, so its slug is fixed and it can't be deleted. You can still add and rename values.</span>
        </div>
      }
      <div class="flex items-center justify-between mb-3">
        <span class="text-[11px] font-bold uppercase tracking-wider text-gray-500">Values</span>
        <span class="text-[11px] text-gray-400 tabular-nums">{{ shownValues.length }} of {{ detail.values.length }} &middot; bar = products using it</span>
      </div>
      @if (detail.values.length > 8) {
        <div class="relative mb-3">
          <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[18px] !h-[18px] !w-[18px] pointer-events-none">search</mat-icon>
          <input type="text" placeholder="Filter values" class="w-full pl-9 pr-3 py-2 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none text-sm" [(ngModel)]="valueSearch" />
        </div>
      }
      @if (detail.values.length === 0) {
        <div class="rounded-2xl bg-gray-50 py-10 text-center">
          <mat-icon class="!text-[30px] !h-[30px] !w-[30px] text-gray-300">sell</mat-icon>
          <p class="mt-1 text-sm text-gray-500">No values yet</p>
          <button type="button" class="mt-2 text-xs font-semibold text-amber-700 hover:underline" (click)="onEdit(detail.attributeId)">Add values</button>
        </div>
      } @else if (shownValues.length === 0) {
        <div class="py-8 text-center text-sm text-gray-400">No values match</div>
      } @else {
        <div class="flex-1 min-h-0 overflow-y-auto -mx-2 px-2">
          @for (v of shownValues; track v.id) {
          <div class="flex items-center gap-3 px-3 py-2 rounded-xl hover:bg-gray-50">
            <div class="min-w-0 flex-1">
              <div class="flex items-baseline justify-between gap-2">
                <span class="text-sm font-semibold text-gray-800 truncate">{{ v.attributeValue }}</span>
                <span class="text-xs tabular-nums flex-shrink-0" [ngClass]="v.productCount ? 'font-bold text-gray-700' : 'text-gray-300'">{{ v.productCount }}</span>
              </div>
              <div class="mt-1 flex items-center gap-2">
                <div class="h-1 flex-1 rounded-full bg-gray-100 overflow-hidden"><div class="h-full rounded-full bg-amber-400" [style.width.%]="v.productCount ? Math.max(valuePct(v.productCount), 3) : 0"></div></div>
                <span class="font-mono text-[10px] text-gray-300 truncate max-w-[120px]">{{ v.attributeValueSlug }}</span>
              </div>
            </div>
          </div>
          }
        </div>
      }
    </div>
    }
  </aside>
  }
</app-main-layout>
